import React from "react";


const HamsterAnimationstill = () => (
  <div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="static_wheel-and-hamster">
    <div className="static_wheel"></div>
    <div className="static_hamster">
      <div className="static_hamster__body">
        <div className="static_hamster__head">
          <div className="static_hamster__ear"></div>
          <div className="static_hamster__eye"></div>
          <div className="static_hamster__nose"></div>
        </div>
        <div className="static_hamster__limb hamster__limb--fr"></div>
        <div className="static_hamster__limb hamster__limb--fl"></div>
        <div className="static_hamster__limb hamster__limb--br"></div>
        <div className="static_hamster__limb hamster__limb--bl"></div>
        <div className="static_hamster__tail"></div>
      </div>
    </div>
    <div className="static_spoke"></div>
  </div>
);

export default HamsterAnimationstill;
